module.exports = __webpack_public_path__ + "static/icons/icon-aniversario.628b9b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-aniversario.png
// module id = vaag
// module chunks = 1